$(document).ready(() => {
    $('.news-letter-block input').change((e) => select(e));
    $('#news-letter-subscription-form').on("submit", function (e) { submitForm(e) });
    $('#get-news-letter-form').on("submit", function (e) { e.preventDefault(); });
    $('#news-letter-block-header').click((e) => getNewsLetterForm(e));
});

function getNewsLetterForm(e) {
    var collapseBlock = $('#collapse-news-letter-block');
    if (collapseBlock.hasClass("form-submitted")) {
        collapseBlock.removeClass("form-submitted")
        $('#collapse-news-letter-block').empty();

        var form = e.target.tagName === 'A' ? $(e.target).parent().find('form') : $(e.target).parent().parent().find('form');
        var valdata = $(form[0]).serialize();

        var block = $('#collapse-news-letter-block');

        $.ajax({
            url: $(form[0]).attr('action'),
            type: 'Get',
            data: valdata,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            success: function (data) {
                block.html(data);
                $('.news-letter-block input').change((e) => select(e));
                $('#news-letter-subscription-form').on("submit", function (e) { submitForm(e) });

                if (grecaptcha) {
                    grecaptcha.render("recaptcha");
                }
            },
        });
    }
}

function select(e) {
    var id = e.target.id;
    if (id.includes('__Selected') && e.target.checked) {
        $('#' + id).parent().addClass('active');
    }
    else if (id.includes('__Selected') && !e.target.checked) {
        $('#' + id).parent().removeClass('active');
    }
}

function submitForm(e) {
    e.preventDefault();
    var form = $(e.target).closest('form');
    $('.news-letter-form-email-input-validation').empty();
    $('.news-letter-form-general-validation').empty();
    var newsLetterSelectItems = $('.news-letter-form-select-wrapper input[id$="__Selected"]');
    var numberOfSelected = 0;
    if (newsLetterSelectItems.length > 1) {
        newsLetterSelectItems.each((i, e) => {
            if (e.id.includes('__Selected')) {
                if (e.checked)
                    numberOfSelected++;
            }
        });
        if (numberOfSelected == 0) {
            $('.news-letter-form-general-validation').html("<img>" + "Vennligst velg minst ett nyhetsbrev");
            return;
        }
    }
    else {
        newsLetterSelectItems.each((i, e) => {
            e.value = true
            e.checked = true
        });
    }
    var valdata = $(form[0]).serialize();

    $.ajax({
        url: $(form[0]).attr('action'),
        type: 'Post',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            console.log(data)
            if (data.success) {
                $('#collapse-news-letter-block').html(
                    '<div class="row">' +
                    '<div class= "container">' +
                    '<div class="row my-2 mt-md-3 mb-md-5">' +
                    '<div class="col-12 col-md-7 offset-md-1">' +
                    '<h3>' +
                    data.confirmationMessage +
                    '</h3 > ' +
                    '<h6>' +
                    data.confirmationDescription +
                    '</h6 > ' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>');
                $("#collapse-news-letter-block").addClass("form-submitted");
            }
            else if (!data.isValidEmail) {
                $('.news-letter-form-email-input-validation').html("<img>" + data.responseMessage);
            }
            else {
                $('.news-letter-form-general-validation').html("<img>" + data.responseMessage);
            }
        }
    });
};